import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { openAlert } from '../actions/modal-actions';

const useOpenAlert = () => {
  const dispatch = useDispatch();
  return useCallback((...args) => dispatch(openAlert(...args)), [dispatch]);
};

export default useOpenAlert;
